
<!--  v-if is in case the object model async fetch hasn't been received yet-->
<loading :loading="!Boolean(handler.endPoint)">
  <template #loading>
    <collapsible-section
      :control-name="dropdownControlId"
      :id="dropdownControlId"
      :is-open="false"
      disabled
      class="collapse-item"
    >
      <template #section-header>
        <xpinner />
      </template>
    </collapsible-section>
  </template>
  <template #loaded>
    <collapsible-section
        class="collapse-item"
        :id="`apiEndPointDataCollapse-${handler.endPoint.client_id}-${dropdownControlId}`"
        control-name="apiEndPointDataCollapse"
        :is-open="isOpen(handler.hasApiEndPointDataMatch('', handler.endPoint, handler.apiMessageType))"
    >
      <template #section-header>
        <row>
          <prefix>
            <icon :glyph="varIOClass(handler.variable)"/>
          </prefix>
          <prefix>
            <icon :glyph="`api`"/>
          </prefix>
          <column>
            {{ handler.rootHeader }}
          </column>
        </row>
      </template>
      <template #section-contents>
        <api-end-point-data
          :handler="handler"
          :q="q"
          :end-point="handler.endPoint"
          :api-message-type="handler.apiMessageType"
          :level="1"
          :path="path"
          default-open
          @select="select"
          :parent-tree-context="computedChildTreeContext"
        ></api-end-point-data>
      </template>
    </collapsible-section>
  </template>
</loading>
